import * as $ from 'jquery';

import 'datatables.net-fixedcolumns-bs4';
import 'datatables.net-bs4';

import 'datatables.net-bs4/css/dataTables.bootstrap4.css';
import 'datatables.net-fixedcolumns-bs4/css/fixedColumns.bootstrap4.css';

import portalConfirm from './portal-confirm';
import portalAlert from './portal-alert';

export default (
    function()
    {

        var $table = $('.table');
        if ($table.length > 0)
        {
            $table.each(function () {
                if (!$(this).hasClass('no-filter') && $(this).find('tbody > tr').length > 1) {
                    var $table = $(this),
                        $tableHead = $('thead', this),
                        $dataTableInstance,
                        timeout;

                    $tableHead.find('tr').clone(true).appendTo( $tableHead );
                    $tableHead.find('tr:eq(1) th').each( function (i)
                    {
                        if (!$(this).data('nofilter'))
                        {
                            var title = $(this).text();
                            $(this).html('<input type="text" placeholder="Search '+title+'" />');

                            $('input', this).on('keyup change', function () {
                                clearTimeout(timeout);
                                timeout = setTimeout($.proxy(function() {
                                    if ( $dataTableInstance.column(i).search() !== this.value ) {
                                        $dataTableInstance
                                            .column(i)
                                            .search( this.value )
                                            .draw();
                                    }
                                }, this), 250);
                            });
                        } else
                        {
                            $(this).empty();
                        }
                    });

                    $dataTableInstance = $table.DataTable({
                        dom: 't',
                        orderCellsTop: true,
                        paging: false,
                        scrollY: '60vh',
                        scrollCollapse: true,
                        scrollX: true,
                        fixedColumns: {
                            leftColumns: $table.data('leftcolumns') ? $table.data('leftcolumns') : 0,
                            rightColumns: $table.data('rightcolumns') ? $table.data('rightcolumns') : 0
                        },
                        columnDefs: [ {
                            targets: 'no-sorting',
                            orderable: false,
                        }]
                    });
                }

                var $tableForm = $(this).closest('form');
                if ($tableForm.length > 0)
                {
                    $tableForm.on('click', 'input.table-check-all', function(e) {
                        var isChecked = $(this).prop('checked');
                        $tableForm.find('input[type=checkbox]').prop('checked', isChecked);
                    });

                    var $bulkActionSelects = $tableForm.find('.select-bulk-actions');
                    if ($bulkActionSelects.length > 0)
                    {
                        $tableForm.find('[type=submit]').on('click', function(e) {
                            e.preventDefault();

                            // Find the checkboxes first
                            if ($tableForm.find('input[type=checkbox]:checked').length > 0)
                            {
                                var $optionChecked = $bulkActionSelects.find(':selected');
                                if ($optionChecked.length > 0)
                                {
                                    if ($optionChecked.val() == '') return false;

                                    if ($optionChecked.data('confirm'))
                                    {
                                        if (portalConfirm($optionChecked.data('confirm')))
                                        {
                                            $tableForm.submit();
                                        }
                                    }
                                }
                                $tableForm.submit();
                            } else
                            {
                                portalAlert('Please select at least one item');
                            }


                        });
                    }

                }
            });
        }

    }($)
);
